"use client"

import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog"
import { STATUS_LABELS, STATUS_BADGE_CLASSES } from "./constants"
import { normalizeStatus } from "@/lib/supabase"
import { NIVEL_LABELS } from "@/lib/educational-levels"

const initialsOf = (name) =>
  String(name || "?")
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase()

/**
 * Modal con los leads de un grupo de atribución (campaña, detalle de landing,
 * tipo de entrada de WhatsApp...). Se abre al hacer clic en el explorador.
 */
export function AttributionLeadsModal({ group, onClose }) {
  if (!group) return null
  const { title, subtitle, accent = "#7a1b33", leads = [] } = group
  const inscritos = leads.filter((l) => normalizeStatus(l.estado_lead) === "inscrito").length

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-lg p-0 gap-0 overflow-hidden rounded-2xl">
        <DialogHeader className="px-5 py-4 border-b border-slate-100 dark:border-slate-800 text-left space-y-0.5" style={{ background: `linear-gradient(135deg, ${accent}14, transparent 70%)` }}>
          <DialogTitle className="text-sm font-extrabold text-slate-900 dark:text-slate-100 flex items-center gap-2">
            <span className="h-2.5 w-2.5 rounded-full flex-shrink-0" style={{ background: accent }} />
            {title}
          </DialogTitle>
          <DialogDescription className="text-[11px] text-slate-500 dark:text-slate-400">
            {subtitle ? `${subtitle} · ` : ""}{leads.length} lead{leads.length !== 1 ? "s" : ""}
            {inscritos > 0 && <span className="text-emerald-600 dark:text-emerald-400 font-bold"> · {inscritos} inscrito{inscritos !== 1 ? "s" : ""}</span>}
          </DialogDescription>
        </DialogHeader>

        <div className="max-h-[55vh] overflow-y-auto px-3 py-2">
          {leads.length === 0 ? (
            <p className="text-center text-xs text-slate-400 py-8">Sin leads en este grupo</p>
          ) : (
            <div className="divide-y divide-slate-100 dark:divide-slate-800">
              {leads.map((l) => {
                const status = normalizeStatus(l.estado_lead)
                return (
                  <div key={l.id} className="flex items-center gap-3 px-2 py-2.5 hover:bg-slate-50 dark:hover:bg-slate-800/50 rounded-lg transition-colors">
                    <div
                      className="h-8 w-8 rounded-full flex items-center justify-center text-[10px] font-black text-white flex-shrink-0"
                      style={{ background: `linear-gradient(135deg, ${accent}cc, ${accent})` }}
                    >
                      {initialsOf(l.nombre_tutor)}
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-[12px] font-bold text-slate-800 dark:text-slate-100 truncate leading-tight">
                        {l.nombre_tutor || "Sin nombre"}
                      </p>
                      <p className="text-[10px] text-slate-400 truncate leading-tight">
                        {[NIVEL_LABELS[(l.nivel_educativo || "").toLowerCase()] || l.nivel_educativo, l.asesor_nombre && `CAP: ${l.asesor_nombre}`]
                          .filter(Boolean)
                          .join(" · ") || l.telefono}
                      </p>
                    </div>
                    <span className={`text-[9px] font-bold px-2 py-1 rounded-md flex-shrink-0 ${STATUS_BADGE_CLASSES[status] || "bg-slate-100 text-slate-600"}`}>
                      {STATUS_LABELS[status] || status || "—"}
                    </span>
                  </div>
                )
              })}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}
